import axios from "axios";
import {Message} from "portal-component";
import store from "../store";
import {checkIfTokenValid,login, logout} from './utils.js';

// create an axios instance
const service = axios.create({
  baseURL: "", // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 1000 * 10 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    let token = store.state.user.token;
    if(store.state.user.userIdentity !== 'Tourist') {
      // 验证token是否有效
      if(!checkIfTokenValid(store.state.user.tokenExpiryDate)) {
        store.dispatch("signOut").then(() => {
          // window.location.href = `${process.env.VUE_APP_CAS_URL}login?service=${encodeURIComponent(process.env.VUE_APP_URL)}`
          login();
        });
      }
    }
    switch (config.headerType) {
      // 门户请求头
      case "portal":
        config.headers["X-Device-Info"] = "PC";
        config.headers["X-Terminal-Info"] = "PC";
        config.headers["X-Id-Token"] = token;
        break;
      // 游客请求头
      case "open":
        config.headers["X-Device-Info"] = "PC";
        config.headers["X-Terminal-Info"] = "PC";
        break;
      // 消息请求头
      case "message":
        config.headers["X-Id-Token"] = token;
        break;
      // 事务请求头
      case "task":
        config.headers["Authorization"] = token;
        break;
      // 认证请求头
      case "cas":
        config.headers["X-Id-Token"] = token;
        break;
      // 请求publicKey
      case "publicKey":
        break;
      // 表单、流程、打印模版设计
      case "forward":
        config.headers["X-FORWARD-ID-TOKEN"] = token;
        break;
      // 部门组织组、群组、角色
      case "admin":
        config.headers["Authorization"] = `Bearer ${token}`;
        break;
      // 景陶
      case "jingtao":
        console.log(token);
        config.headers["token"] = token;
        break;
      // 默认游客请求头
      default:
        config.headers["X-Device-Info"] = "PC";
        config.headers["X-Terminal-Info"] = "PC";
        if (token) config.headers["X-Id-Token"] = token;
        break;
    }

    // get参数编码
    if (config.method === "get" && config.params) {
      let url = config.url;
      url += "?";
      config.params.random_number = Math.floor(Math.random() * ( 1000 + 1)); //添加随机数解决ie缓存get请求问题
      let keys = Object.keys(config.params);
      for (let key of keys) {
        if (config.params[key] !== undefined && config.params[key] !== "") {
          url += `${encodeURIComponent(key)}=${encodeURIComponent(
            config.params[key]
          )}&`;
        }
      }
      url = url.substring(0, url.length - 1);
      config.params = {};
      config.url = url;
    }
    return config;
  },
  error => {
    //     Message({
    //       message: error.response.data?.message,
    //       type: "error",
    //       duration: 5 * 1000
    //     });
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    // if (response.data.code === -1) {
    //   store.dispatch("signOut").then(() => {
    //     window.location.href = `${process.env.VUE_APP_CAS_URL}login?service=${encodeURIComponent(process.env.VUE_APP_URL)}`
    //   });
    // }
    // else if (response.status !== 200) {
    //   Message.error(response.message || "Error");
    // }
    // Cannot read property 'data' of undefined
    return response.data;
  },
  error => {
    // if (error.response?.status === -1001) {
    //   store.dispatch("signOut").then(() => {
    //     let casUrl = `${process.env.VUE_APP_CAS_URL}login?service=${encodeURIComponent(process.env.VUE_APP_URL)}`
    //     // window.location.href = casUrl
    //
    //   });
    // } else {
    //   if(!error.response?.config?.hideMessage){
    //     Message({
    //       message: error.response.data?.message,
    //       type: "error",
    //       duration: 5 * 1000
    //     });
    //   }
    // }
    return Promise.reject(error);
  }
);

export default service;
